// extracted by mini-css-extract-plugin
var _1 = "SolutionTrialsStandard__bottom--uiIwY ProblemGeneral__bottom--ORYse";
var _2 = "SolutionTrialsStandard__left--rKNkK ProblemGeneral__left--azXxt";
var _3 = "SolutionTrialsStandard__line--pCaKl";
var _4 = "SolutionTrialsStandard__right--ESJSy ProblemGeneral__right--lXqU2";
var _5 = "SolutionTrialsStandard__title--VxnG0 ProblemGeneral__title--ZRR_t TrainerGeneral__robotoSlab--mNKKu CoreGeneral__robotoSlab--X8lgW";
var _6 = "SolutionTrialsStandard__top--FZu31 ProblemGeneral__top--ODmXk";
export { _1 as "bottom", _2 as "left", _3 as "line", _4 as "right", _5 as "title", _6 as "top" }
